import { c as _c } from "react/compiler-runtime";
import MuxVideo from "@mux/mux-video-react";
import { browserData } from "library/deviceDetection";
import { ScreenContext } from "library/ScreenContext";
import { EagerImages } from "library/StaticImage";
import type { SanityImageData } from "library/sanity/SanityImage";
import UniversalImage from "library/UniversalImage";
import { useCombinedRefs } from "library/useCombinedRefs";
import type { StaticImageData } from "next/image";
import { use, useEffect, useRef, useState } from "react";
import { withComponent } from "library/styled/withComponent";
import { Container, MainVideo as MainVideo___raw, PosterImage as PosterImage___raw, PlaceholderDiv } from "data:text/javascript;base64,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";
export function CarouselBackgroundVideo(t0) {
  const $ = _c(55);
  const {
    playbackId,
    videoBlurUrl,
    videoAspectRatio,
    videoDuration,
    poster,
    play: t1,
    muted: t2,
    minResolution: t3,
    maxResolution,
    renditionOrder,
    className,
    loop,
    ref: containerRef,
    videoRef: externalVideoRef,
    onEnded,
    onTimeUpdate,
    onLoadedMetadata,
    onPlaying,
    safariOptimized: t4,
    eager: t5
  } = t0;
  const play = t1 === undefined ? true : t1;
  const muted = t2 === undefined ? true : t2;
  const minResolution = t3 === undefined ? "480p" : t3;
  const safariOptimized = t4 === undefined ? false : t4;
  const eager = t5 === undefined ? false : t5;
  const video = useRef(null);
  const combinedVideoRef = useCombinedRefs(externalVideoRef, video);
  const placeholderRef = useRef(null);
  const [playbackFailure, setPlaybackFailure] = useState();
  const {
    innerWidth
  } = use(ScreenContext);
  const posterSize = Math.min(1920, Math.max(300, Math.round(innerWidth / 100) * 100));
  const [isSafari, setIsSafari] = useState(false);
  let t6;
  let t7;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => {
      setIsSafari(browserData.isSafari === true);
    };
    t7 = [];
    $[0] = t6;
    $[1] = t7;
  } else {
    t6 = $[0];
    t7 = $[1];
  }
  useEffect(t6, t7);
  const useSafariOptimization = safariOptimized && isSafari;
  const [shouldRenderVideo, setShouldRenderVideo] = useState(false);
  const [videoReady, setVideoReady] = useState(false);
  const [readyForId, setReadyForId] = useState(playbackId);
  if (playbackFailure && playbackFailure.videoId !== playbackId) {
    setPlaybackFailure(undefined);
  }
  if (readyForId !== playbackId) {
    setReadyForId(playbackId);
    setVideoReady(false);
  }
  let t8;
  let t9;
  if ($[2] !== onEnded || $[3] !== play || $[4] !== playbackFailure || $[5] !== playbackId || $[6] !== shouldRenderVideo) {
    t8 = () => {
      const videoEl = video.current;
      if (!shouldRenderVideo || !videoEl || playbackFailure) {
        return;
      }
      if (!play) {
        videoEl.pause();
        return;
      }
      let retryTimeout;
      let cancelled = false;
      const fail = () => {
        cancelled = true;
        clearTimeout(retryTimeout);
        if (playbackId) {
          setPlaybackFailure({
            videoId: playbackId
          });
        }
        onEnded?.();
      };
      const attemptPlay = () => {
        if (cancelled) {
          return;
        }
        videoEl.play().catch(() => {
          if (cancelled) {
            return;
          }
          retryTimeout = setTimeout(attemptPlay, 250);
        });
      };
      videoEl.addEventListener("error", fail);
      attemptPlay();
      return () => {
        cancelled = true;
        clearTimeout(retryTimeout);
        videoEl.removeEventListener("error", fail);
      };
    };
    t9 = [play, shouldRenderVideo, playbackFailure, playbackId, onEnded];
    $[2] = onEnded;
    $[3] = play;
    $[4] = playbackFailure;
    $[5] = playbackId;
    $[6] = shouldRenderVideo;
    $[7] = t8;
    $[8] = t9;
  } else {
    t8 = $[7];
    t9 = $[8];
  }
  useEffect(t8, t9);
  let t10;
  let t11;
  if ($[9] !== eager || $[10] !== useSafariOptimization) {
    t10 = () => {
      if (useSafariOptimization || eager) {
        setShouldRenderVideo(true);
        return;
      }
      const observer = new IntersectionObserver(entries => {
        if (entries[0]?.isIntersecting) {
          setShouldRenderVideo(true);
          observer.disconnect();
        }
      }, {
        rootMargin: "400px"
      });
      const elementToObserve = placeholderRef.current;
      if (elementToObserve) {
        observer.observe(elementToObserve);
      }
      return () => observer.disconnect();
    };
    t11 = [useSafariOptimization, eager];
    $[9] = eager;
    $[10] = useSafariOptimization;
    $[11] = t10;
    $[12] = t11;
  } else {
    t10 = $[11];
    t11 = $[12];
  }
  useEffect(t10, t11);
  let t12;
  if ($[13] !== onTimeUpdate) {
    t12 = e => {
      const videoElement = e.currentTarget;
      if (onTimeUpdate && videoElement.duration) {
        onTimeUpdate(videoElement.currentTime, videoElement.duration);
      }
    };
    $[13] = onTimeUpdate;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  const handleTimeUpdate = t12;
  let t13;
  if ($[15] !== onLoadedMetadata) {
    t13 = e_0 => {
      const videoElement_0 = e_0.currentTarget;
      if (onLoadedMetadata && videoElement_0.duration) {
        onLoadedMetadata(videoElement_0.duration);
      }
    };
    $[15] = onLoadedMetadata;
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  const handleLoadedMetadata = t13;
  let posterElement = null;
  if (poster && "src" in poster) {
    let t14;
    if ($[17] !== poster) {
      t14 = <PosterImage src={poster} alt="" />;
      $[17] = poster;
      $[18] = t14;
    } else {
      t14 = $[18];
    }
    posterElement = t14;
  } else {
    if (poster) {
      let t14;
      if ($[19] !== poster) {
        t14 = <PosterImage src={poster} alt="" />;
        $[19] = poster;
        $[20] = t14;
      } else {
        t14 = $[20];
      }
      posterElement = t14;
    }
  }
  if (posterElement) {
    let t14;
    if ($[21] !== posterElement) {
      t14 = <EagerImages>{posterElement}</EagerImages>;
      $[21] = posterElement;
      $[22] = t14;
    } else {
      t14 = $[22];
    }
    posterElement = t14;
  }
  const t14 = !poster && videoBlurUrl ? `url('${videoBlurUrl}')` : undefined;
  let t15;
  if ($[23] !== t14 || $[24] !== videoAspectRatio) {
    t15 = {
      aspectRatio: videoAspectRatio,
      backgroundImage: t14
    };
    $[23] = t14;
    $[24] = videoAspectRatio;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  const t16 = !poster && playbackId ? `url(https://image.mux.com/${playbackId}/thumbnail.webp?time=0&width=${posterSize})` : undefined;
  let t17;
  if ($[26] !== t16) {
    t17 = {
      backgroundImage: t16
    };
    $[26] = t16;
    $[27] = t17;
  } else {
    t17 = $[27];
  }
  let t18;
  if ($[28] !== posterElement || $[29] !== t17) {
    t18 = <PlaceholderDiv ref={placeholderRef} style={t17}>{posterElement}</PlaceholderDiv>;
    $[28] = posterElement;
    $[29] = t17;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  let t19;
  if ($[31] !== combinedVideoRef || $[32] !== handleLoadedMetadata || $[33] !== handleTimeUpdate || $[34] !== loop || $[35] !== maxResolution || $[36] !== minResolution || $[37] !== muted || $[38] !== onEnded || $[39] !== onPlaying || $[40] !== playbackFailure || $[41] !== playbackId || $[42] !== poster || $[43] !== posterSize || $[44] !== renditionOrder || $[45] !== shouldRenderVideo || $[46] !== videoDuration || $[47] !== videoReady) {
    t19 = shouldRenderVideo && <MainVideo ref={combinedVideoRef} src={playbackFailure || !playbackId ? undefined : `https://stream.mux.com/${playbackId}.m3u8?min_resolution=${minResolution}${maxResolution ? `&max_resolution=${maxResolution}` : ""}${renditionOrder ? `&rendition_order=${renditionOrder}` : ""}`} preload="auto" muted={muted} playsInline={true} loop={loop} poster={poster ? undefined : playbackFailure ? `https://image.mux.com/${playbackId}/thumbnail.webp?time=${videoDuration}&width=${posterSize}` : `https://image.mux.com/${playbackId}/thumbnail.webp?time=0&width=${posterSize}`} streamType="on-demand" style={{
      opacity: videoReady ? 1 : 0
    }} onCanPlay={() => setVideoReady(true)} onEnded={onEnded} onTimeUpdate={handleTimeUpdate} onLoadedMetadata={handleLoadedMetadata} onPlaying={onPlaying} />;
    $[31] = combinedVideoRef;
    $[32] = handleLoadedMetadata;
    $[33] = handleTimeUpdate;
    $[34] = loop;
    $[35] = maxResolution;
    $[36] = minResolution;
    $[37] = muted;
    $[38] = onEnded;
    $[39] = onPlaying;
    $[40] = playbackFailure;
    $[41] = playbackId;
    $[42] = poster;
    $[43] = posterSize;
    $[44] = renditionOrder;
    $[45] = shouldRenderVideo;
    $[46] = videoDuration;
    $[47] = videoReady;
    $[48] = t19;
  } else {
    t19 = $[48];
  }
  let t20;
  if ($[49] !== className || $[50] !== containerRef || $[51] !== t15 || $[52] !== t18 || $[53] !== t19) {
    t20 = <Container ref={containerRef} className={className} style={t15}>{t18}{t19}</Container>;
    $[49] = className;
    $[50] = containerRef;
    $[51] = t15;
    $[52] = t18;
    $[53] = t19;
    $[54] = t20;
  } else {
    t20 = $[54];
  }
  return t20;
}
const MainVideo = withComponent(MuxVideo, MainVideo___raw);
const PosterImage = withComponent(UniversalImage, PosterImage___raw);